import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingFoundPartners = createSelector(
  [selectLandingState],
  ({ foundPartners }) => {
    return foundPartners
  }
)
